module.exports = __webpack_public_path__ + "img/share-ts.878ca605.png";